import styled from 'styled-components';

export const DashboardWrapper = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
`;

export const Square = styled.div`
  width: 180px;
  height: 82px;
  background-color: #3498db;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
  border-radius: 20px;
  flex-wrap: wrap;
`;

export const SpanTitle = styled.span`
  width: 90%;
  display: block;
  text-align: center;
  padding: 5px 0 0 5px;
  position: relative;
  top: -25px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const SpanQuantity = styled.span`
  font-size: 27px;
  font-weight: 600;
  position: absolute;
  margin-top: 17px;
`;

export const ChartsContainer = styled.div`
  width: 100%;
  margin-top: 45px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: stretch;
  gap: 24px;

  & > div {
    flex: 1 1 350px;
    min-width: 350px;
    max-width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  @media (max-width: 900px) {
    flex-direction: column;
    gap: 16px;
    & > div {
      min-width: 0;
      width: 100%;
    }
  }
`;
